import { useState } from 'react';

export default function useToken() {
  const getToken = (): string|null => {
    return localStorage.getItem('token');
  };

  const [token, setToken] = useState(getToken());

  const saveToken = (userToken: string) => {
    localStorage.setItem('token', userToken);
    setToken(userToken);
  };

  const removeToken = () => {
    localStorage.removeItem("token");
    setToken("");
  };

  return {
    removeToken: removeToken,
    setToken: saveToken,
    token
  }
}
